import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { QuestionnairesState } from "@teamprevent/common/questionnaires/model";

import { selectQuestionnaireAsQuestionnaireConfigFactory } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { flatten, uniq, values } from "lodash";

import { QuestionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { GENERIC_CASE_QUESTIONNAIRE_KEY, GenericCaseForm } from "@teamprevent/common/genericCase/components/GenericCaseForm";

import { Container, Header, Loader, Segment } from "semantic-ui-react";

import { ApplicationState } from "../../applicationState";

import { loadLoadGenericCaseForm } from "../actions";
import { ohCaseSelector } from "../../crud/ohCase/selectors";

export const ReadonlyGenericCaseForm: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const questionnaireConfig: QuestionnaireConfig = useSelector((state: { questionnaires: QuestionnairesState }) =>
        selectQuestionnaireAsQuestionnaireConfigFactory(GENERIC_CASE_QUESTIONNAIRE_KEY)(state));
    const ohCase = useSelector((state: ApplicationState) => ohCaseSelector(state));

    const customerDetails = useSelector((state: ApplicationState) => state.customerDetails);
    const userFromState = useSelector((state: ApplicationState) => state.currentUser);
    const currentUser = React.useMemo(() => {
        return {
            name: userFromState.name,
            id: userFromState.id!,
            email: userFromState.email!,
            mobilePhone: userFromState.mobilePhone,
            roles: userFromState.roles
        };
    }, [userFromState]);

    const orgLevels = useSelector((state: ApplicationState) => state.referralForm.orgLevels);
    const hrRepresentatives = useSelector((state: ApplicationState) => state.referralForm.hrRepresentatives);
    const questions = useSelector((state: ApplicationState) => state.questionnaires[GENERIC_CASE_QUESTIONNAIRE_KEY] ?
        uniq(flatten(state.questionnaires[GENERIC_CASE_QUESTIONNAIRE_KEY].sections.map(section => values(section.questions)))) :
        []);

    React.useEffect(() => {
        if (ohCaseId) {
            dispatch(loadLoadGenericCaseForm(ohCaseId, GENERIC_CASE_QUESTIONNAIRE_KEY));
        }
    }, [dispatch, ohCaseId]);

    if (!questionnaireConfig || !customerDetails) {
        return <Loader active />;
    }

    if (questionnaireConfig.questions.length === 0) {
        return (
            <Header as="h1" textAlign="center">A Generic Case Form does not exist for this OH Case.</Header>
        );
    }

    return (
        <Container className="generic-case-form">
            <Container>
                <Segment basic>
                    <Header as="h1">{ohCase.caseType}</Header>
                </Segment>
            </Container>
            <GenericCaseForm
                readonly={true}
                genericCaseTypes={customerDetails.genericCaseTypes}
                currentUser={ currentUser }
                orgLevels={orgLevels}
                hrRepresentatives={hrRepresentatives}
                questionnaireConfig={questionnaireConfig}
                questions={questions}
            />
        </Container>
    );
};
